import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const InnerWrapper = styled(Flex)`
  width: 100vw;
  ${({ theme }) => css`
    margin: ${theme.spacing(4)} auto;
  `};

  .swiper-slide {
    width: 250px;
  }
`;
